module.exports = __webpack_public_path__ + "static/media/pymes-card.fb6dab87.svg";